import React from 'react';

export const ContactSuccessIcon = () => (
  <svg width='38' height='38' viewBox='0 0 38 38' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <circle cx='19' cy='19' r='19' fill='white' />
    <path
      d='M18.5844 11.5032C18.115 11.5098 17.6511 11.5285 17.1927 11.559C13.7061 11.7907 10.9294 14.6065 10.7011 18.1423C10.6569 18.8416 10.6569 19.543 10.7011 20.2423C10.7844 21.5298 11.3536 22.7223 12.0244 23.729C12.4136 24.4332 12.1569 25.3123 11.7511 26.0815C11.4594 26.6357 11.3127 26.9123 11.4302 27.1123C11.5469 27.3123 11.8094 27.319 12.3336 27.3315C13.3711 27.3565 14.0702 27.0632 14.6252 26.654C14.9394 26.4215 15.0969 26.3057 15.2052 26.2923C15.3136 26.279 15.5277 26.3673 15.9544 26.5423C16.3377 26.7007 16.7836 26.7982 17.1919 26.8257C18.3794 26.904 19.6202 26.904 20.8102 26.8257C24.2961 26.5932 27.0727 23.7773 27.3011 20.2423C27.3452 19.5507 27.3452 18.834 27.3011 18.1423C27.2555 17.4379 27.1061 16.744 26.8577 16.0832'
      stroke='#171717'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M20.6693 13.9998C20.6693 13.9998 21.5026 13.9998 22.3359 15.6665C22.3359 15.6665 24.9834 11.4998 27.3359 10.6665M16.0859 21.4998H21.9193M16.0859 17.3332H19.0026'
      stroke='#171717'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

const ContactFormFields = ({ formData, errors, handleChange, idPrefix = '' }) => {
  const id = (name) => (idPrefix ? `${idPrefix}-${name}` : name);

  return (
    <>
      <div className='form-row-custom'>
        <div className={`form-group-custom ${errors.name ? 'has-error' : ''}`}>
          <label htmlFor={id('name')}>
            NAME<span aria-hidden='true'>*</span>
          </label>
          <input
            type='text'
            id={id('name')}
            name='name'
            placeholder='First Name Last Name'
            value={formData.name}
            onChange={handleChange}
            required
            aria-required='true'
            aria-invalid={!!errors.name}
            aria-describedby={errors.name ? id('name-error') : undefined}
          />
          {errors.name && (
            <span className='error-text' id={id('name-error')} role='alert'>
              {errors.name}
            </span>
          )}
        </div>
        <div className={`form-group-custom ${errors.email ? 'has-error' : ''}`}>
          <label htmlFor={id('email')}>
            EMAIL<span aria-hidden='true'>*</span>
          </label>
          <input
            type='email'
            id={id('email')}
            name='email'
            placeholder='example@youremail.com'
            value={formData.email}
            onChange={handleChange}
            required
            aria-required='true'
            aria-invalid={!!errors.email}
            aria-describedby={errors.email ? id('email-error') : undefined}
          />
          {errors.email && (
            <span className='error-text' id={id('email-error')} role='alert'>
              {errors.email}
            </span>
          )}
        </div>
      </div>

      <div className='form-row-custom'>
        <div className={`form-group-custom ${errors.phone ? 'has-error' : ''}`}>
          <label htmlFor={id('phone')}>PHONE</label>
          <input
            type='tel'
            id={id('phone')}
            name='phone'
            placeholder='(123) 456 - 7890'
            value={formData.phone}
            onChange={handleChange}
            aria-invalid={!!errors.phone}
            aria-describedby={errors.phone ? id('phone-error') : undefined}
          />
          {errors.phone && (
            <span className='error-text' id={id('phone-error')} role='alert'>
              {errors.phone}
            </span>
          )}
        </div>
        <div className='form-group-custom'>
          <label htmlFor={id('agency')}>AGENCY OR BRAND</label>
          <input
            type='text'
            id={id('agency')}
            name='agency'
            placeholder='Agency or brand'
            value={formData.agency}
            onChange={handleChange}
          />
        </div>
      </div>

      <div className='form-group-custom'>
        <label htmlFor={id('industry')}>INDUSTRY</label>
        <input
          type='text'
          id={id('industry')}
          name='industry'
          placeholder='Describe your industry here...'
          value={formData.industry}
          onChange={handleChange}
        />
      </div>

      <div className='form-group-custom'>
        <label htmlFor={id('message')}>MESSAGE</label>
        <textarea
          id={id('message')}
          name='message'
          rows='4'
          placeholder='Type your message here... (optional)'
          value={formData.message}
          onChange={handleChange}
        />
      </div>
    </>
  );
};

export default ContactFormFields;
